import * as React from "react";
import { TabContentsProps } from "./typings";
import { BlossomComponents } from "components/flexFramework/BlossomComponents/BlossomComponents";

export const TabContents = (props: TabContentsProps) => (
  <BlossomComponents flexComponents={props.flexComponent.modules} context={props.context} />
);

export default TabContents;
